import { useRef, useState } from "react"
import './IntroVideoCard.css'

const video = "/api/files/videos/Info Session (2026).mp4"

export const IntroVideoCard = () => {
  const [showVideo, setShowVideo] = useState(false)
  const videoRef = useRef()
  const startVideo = () => {
    if (showVideo) return
    setShowVideo(true)
    if (!videoRef) return
    videoRef.current.currentTime = 0
    videoRef.current.play()
  }
  const stopVideo = () => {
    if (!showVideo) return
    setShowVideo(false)
    if (!videoRef) return
    videoRef.current.pause()
  }

  return (
    <div className="intro-video-card">
      <div className="intro-video-body">
        <h5 className="intro-video-title">Mentorship Info Session</h5>
        <div className="intro-video-date">Jan 23, 2026</div>
        <p className="intro-video-desc">
          This hour-long session covers what CLEAR is, the program objectives, and
          what CLEAR might mean for you.
        </p>
      </div>
      <div className="video-wrapper">
        <video
          src={video}
          ref={videoRef}
          style={{ display: showVideo ? undefined : 'none' }}
          controls
          onEnded={stopVideo}
        />
        <button
          className="video-button"
          style={{ display: showVideo ? 'none' : undefined }}
          onClick={startVideo}
        >
          <svg className="icon">
            <use xlinkHref="#icon-play_circle_outline"></use>
          </svg>
        </button>
      </div>
    </div>
  )
}
